import React, { Component } from "react";
import NavBarHeader from "../NavBarHeader/NavBarHeader";
import ScrolltoTop from "../ScrollTop/ScrollTop";
import "./ID_NEappendix.css";
import Footer_contact_tab from "../Footerpage/Footer_contact_tab";
import { use } from "react";
import TranslationFile from "../15-Translation/locale/Translation_apps.json"
let userSelectedLanguage;

class ID_NEappendix extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  scrollToContactUs() {
    this.props.callBack();
  }

  componentWillMount() {
    userSelectedLanguage = localStorage.getItem("selectedLanguage");

    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <NavBarHeader />
        <div className="ID_Homepage">
          <br></br>
          <br></br>
         
          <section
            style={{
              fontSize: "25px",
              fontWeight: "800",
              textAlign: "center",
            }}
          >
            {TranslationFile.ComingSoonText[userSelectedLanguage]}
          </section>
          
        </div>
        <ScrolltoTop />
        <Footer_contact_tab sideBar={this.state.sideBarStatus} isCorpPortal={false} isHomePage={true} />

      </div>
    );
  }
}
export default ID_NEappendix;
